export default __webpack_public_path__ + "static/media/Animation.85ca244e.gif";